import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from "react-redux";

import Home, { ALLOWED_PATHS as HOME_PATHS } from "./Home";
import Publisher, { ALLOWED_PATHS as PUBLISHER_PATHS } from './Publisher';
import Advertiser, { ALLOWED_PATHS as ADVERTISER_PATHS } from './Advertiser';
import NotFound from '../misc/NotFound';

import Balaclava from 'cityads-v3/components/Balaclava';
import { CookiePolicyPopup } from 'cityads-v3/components/CookiePolicy/CookiePolicy';

import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

@connect(
  state => ({
    languageList: state.language.languageList,
  })
)
@withTranslation(['main'], { i18n, wait: !!window })
export default class Main extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    languageList: PropTypes.array,
  }

  render() {
    const { t } = this.props;

    return (
      <>
        <Balaclava
          slogan   = {t('slogan')}
          menuShow = {true}
          menu     = {[
            {
              id: 'publisher',
              title: t('main:tab_publisher'),
              route: '/main/publisher'
            }, {
              id: 'advertiser',
              title: t('main:tab_advertiser'),
              route: '/main/advertiser'
            }
          ]}
        />

        <Switch>
          <Route strict exact path={'/main/publisher/:sub(' + PUBLISHER_PATHS.join('|') + ')?'} component={Publisher} />
          <Route strict exact path={'/main/advertiser/:sub(' + ADVERTISER_PATHS.join('|') + ')?'} component={Advertiser} />
          <Route path={'*/cookiePolicy'} children={({ match }) => (
            <CookiePolicyPopup/>
          )} />
          <Route strict exact path={'/main/:sub(' + HOME_PATHS.join('|') + ')?'} component={Home} />

          <Route path={'/main/financial_api'} render={() => (
            <Redirect to="/main/firano" />
          )} />

          <Route path={'/main/:sub(' + this.props.languageList.join('|') + ')'} render={() => (
            <Redirect to="/main" />
          )}/>

          <Route component={NotFound}/>
        </Switch>
      </>
    );
  }
}
